import { Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { TranslateService } from '@ngx-translate/core';

import { HTTPService, HelperService, DateService, DataService, FormatService, CalculationService } from 'app/services';

import { findingItemColorLabel, findingItemColorLabelFR, findingItemIcon, inspectionItemColorIndex, serviceAuthConsts, tirePositionOptions } from 'app/constants';
import { demoEstimateData } from 'app/constants/demo-estimate';
import { currency } from 'app/constants/currency.constants';
import { concernsTypeList } from 'app/constants/csv/constants';
import { getLanguagePreferences } from 'app/constants/language-translate';

import { find, findIndex, toLower } from 'lodash';

@Component({
  selector: 'app-repair-order-pdf',
  templateUrl: './repair-order-pdf.component.html',
  styleUrls: ['./repair-order-pdf.component.scss'],
})
export class RepairOrderPdfComponent implements OnInit {
  @ViewChild('leftBar') leftBar: ElementRef;
  @ViewChild('rightBar') rightBar: ElementRef;

  company: any = { address: {} };
  customer: any = {};
  vehicle: any = {};
  pdfAuthHistory: any[] = [];
  concerns: any[] = [];
  orderInspectionItems: any[];
  addedServicesWithConcerns: string[] = [];
  order: any = {};
  concernTypes = concernsTypeList;
  usd: string = currency.USD;
  disclaimer: string = '';
  invDisclaimer: string = '';
  pdfLogoType: string = '';
  milage: any = {};
  mileageOut: any = {};
  pdfImage: any = {};
  deferredServices: any = [];
  isDeferredServiceEnabled: boolean = false;
  isDeferredServiceVisibleOnInv: boolean = false;
  isFlatRateSubItemVisibleToCust: boolean = false;
  isFlatRateSubItemDescVisibleToCust: boolean = false;
  isFlatRateSubItemQtyVisibleToCust: boolean = false;
  displayExternalServiceNotes: boolean = false;
  showSign: boolean = true;
  estimateId: string;
  techServiceGroup: any = {};
  flatRateFee: any = {};
  unAssignedServiceGroup: any = { services: [] };
  isLoading = true;
  isFloridaStateComplianceUpdates = false;
  isCAStateComplianceEnabled = false;
  isDisplayAuthorizationLogs = false;
  isTaxDetailsBreakDown: boolean = false;
  isPassThroughTaxEnable: boolean = false;
  serviceItemsBreakdown: boolean = false;
  isShowPaymentInPdf: boolean = false;
  serviceLevelDiscount: any[] = [];
  disclaimerMsg = 'By signing this document, you agree to the Terms and Conditions mentioned below.';
  paymentHistory: any = [];
  isGlobalPaymentEnabled: boolean = false;
  isShowPaymentDetails: boolean = false;
  isrestrictAuthLogs: boolean = false;
  isTrackMileageInAndOut: boolean = false;
  showDisclaimerLeftSide = false;
  isPaymentSectionVisible: boolean = false;
  shopAppSettings: any = {};
  isEnhancedTSEnabled: boolean = false;
  isTreadDepthVisibleOnInvoice: boolean = false;
  isCustomerConcernEnabled: boolean = false;
  defaultMileageUnit: any;
  isFinalizedAsThirdParty: boolean = false;
  isPartWarrantiesEnabled: boolean = false;
  isTireWarrantyPolicyEnabled: boolean = false;
  isWarrantyNumberAddonEnabled: boolean = false;
  warrantyDisclaimer: string = '';
  tireWarrantyPolicy: string = '';
  warrantiedTires: Array<any> = [];

  defaultConcernTypesCount = {
    customerConcern: 0,
    safetyIssue: 0,
    monitorTimeMileage: 0,
    whileHere: 0,
    maintainanceItem: 0,
    cosmeticItem: 0,
  };
  concernTypesCount = { ...this.defaultConcernTypesCount };
  isDvi2Enabled: boolean = false;
  isTireStorage2Enabled: boolean = false;

  currentLang: string = 'en';
  token: string = '';
  companyLocalization: boolean = false;
  serviceAuthLabel = {
    pending: 'Pending authorization',
    approved: 'Authorized',
    deferred: 'Deferred',
    declined: 'Deferred',
    archived: 'Archived',
    deferredLocked: 'Deferred',
  };

  constructor(
    public dataService: DataService,
    private dateService: DateService,
    private activatedRoute: ActivatedRoute,
    private httpService: HTTPService,
    public helperService: HelperService,
    private renderer: Renderer2,
    public formatService: FormatService,
    private calculationService: CalculationService,
    private translate: TranslateService,
  ) {
    this.renderer.addClass(document.body, 'scroll-inspection');
  }

  ngOnInit() {
    const token = this.activatedRoute.snapshot.paramMap.get('appt_conf_token');
    this.token = token;
    this.companyLocalization = this.activatedRoute.snapshot.queryParamMap.get('localization') === 'true';
    if (this.companyLocalization) {
      this.currentLang = this.activatedRoute.snapshot.queryParamMap.get('lang');
      this.currentLang = this.helperService.validatePreferredLang(this.currentLang);
      this.currentLang = toLower(this.currentLang);
      this.translate.setDefaultLang(this.currentLang);

      if (this.currentLang === 'fr' || this.currentLang === 'FR') {
        this.disclaimerMsg = 'En signant ce document, vous acceptez les conditions générales mentionnées ci-dessous.';
      } else {
        this.disclaimerMsg = 'By signing this document, you agree to the Terms and Conditions mentioned below.';
      }
    }

    this.translate.use(this.currentLang);
    this.translate.get('estimate').subscribe((translations: any) => {
      this.serviceAuthLabel = translations;
    });
    const showSign = this.activatedRoute.snapshot.queryParamMap.get('showSign');
    const isImportedOrder = this.activatedRoute.snapshot.queryParamMap.get('isImport');
    const isShowPaymentDetails = this.activatedRoute.snapshot.queryParamMap.get('isShowPaymentDetails');
    const isrestrictAuthLogs = this.activatedRoute.snapshot.queryParamMap.get('isResticAuthLogs');
    const id = this.activatedRoute.snapshot.paramMap.get('id');
    this.estimateId = id;

    if (showSign === 'false') {
      this.showSign = false;
    }
    if (isShowPaymentDetails === 'true') {
      this.isShowPaymentDetails = true;
    }
    if (isrestrictAuthLogs === 'true') {
      this.isrestrictAuthLogs = true;
    }

    if (['8', '10', '12'].includes(`${token}`)) {
      demoEstimateData.company.appsettings.pdfFontSize = Number(token);
      demoEstimateData.company.appsettings.customerPreviewFontSize = Number(token);
      this.setData(demoEstimateData);
    } else if (token) {
      this.getEstimatesById(token);
    } else if (id) {
      if (isImportedOrder === 'true') {
        this.getImportedEstimateById(id);
      } else {
        this.getEstimatesByEstimateId(id);
      }
    }
    setTimeout(() => {
      if (this.leftBar && this.rightBar && this.leftBar.nativeElement.offsetHeight > this.rightBar.nativeElement.offsetHeight) {
        this.showDisclaimerLeftSide = true;
      } else {
        this.showDisclaimerLeftSide = false;
      }

    }, 2000);
    setTimeout(() => {
      console.log('this.showDisclaimerLeftSide', this.order.services);
    }, 5000);
  }

  getEstimatesById(data: any) {
    this.httpService.getEstimateByIdCustomerTokenPreview(data, this.isShowPaymentDetails).then(
      (res: any) => {
        this.estimateId = res.estimate._id;
        this.setData(res);
      },
      (error) => {
        this.helperService.showToaster('error', error);
      },
    );
  }

  // get by estimate id
  getEstimatesByEstimateId(id: any) {
    let url = id;
    url += `?isShowPaymentDetails=true`;
    this.httpService.getEstimateByIdForTokenPreview(url).then(
      (res: any) => {
        this.setData(res);
      },
      (error) => {
        this.helperService.showToaster('error', error);
      },
    );
  }

  getImportedEstimateById(id: any) {
    this.httpService.getImportedROForCustomer(id).then(
      (res: any) => {
        this.setData(res);
      },
      (error) => {
        this.helperService.showToaster('error', error);
      },
    );
  }

  setConcernTypesCount() {
    this.concernTypesCount = { ...this.defaultConcernTypesCount };
    this.concerns.forEach((concern: any) => {
      this.concernTypesCount[concern.concernType]++;
      concern.concernNumber = this.concernTypesCount[concern.concernType];
    });
  }

  async setData(res: any) {
    const hazmatFeeItems: { title: string; subTotal: number, titleFR: string }[] = [];
    this.company = res.company || {};
    this.paymentHistory = this.helperService.setPaymentHistory(res.payments, this.company.timezone);
    this.isGlobalPaymentEnabled = res.settings?.isGlobalPayConnected ?? false;
    if (this.paymentHistory?.length) {
      this.paymentHistory = this.paymentHistory.filter((history: any) => history?.paymentType !== 'writeOff');
    }

    if (res?.estimate?.finalizeType === 'thirdPartyAccounts') {
      this.isFinalizedAsThirdParty = true;
    } else {
      this.isFinalizedAsThirdParty = false;
    }

    const shop = res.shop;
    this.shopAppSettings = shop?.appsettings || {};
    const appsettings = this.company?.appsettings;

    if (shop) {
      if (shop.pdfLogo) {
        this.company.logo = shop.pdfLogo;
        this.company.pdfLogo = shop.pdfLogo;
        this.pdfLogoType = shop?.appsettings?.pdfLogoFormatType;
      } else {
        this.company.logo = shop.logo;
        this.company.pdfLogo = shop.pdfLogo;
      }
      if (shop.regNumber) {
        this.company.regNumber = shop.regNumber;
      }
    } else if (this.company.pdfLogo) {
      this.company.logo = this.company.pdfLogo;
      this.pdfLogoType = appsettings.pdfLogoFormatType;
    }

    if (appsettings) {
      this.isDeferredServiceEnabled = appsettings.isDeferredServiceEnabled;
      this.isDeferredServiceVisibleOnInv = appsettings.isDeferredServiceVisibleOnInv;
      this.isFlatRateSubItemVisibleToCust = appsettings.isFlatRateSubItemVisibleToCust;
      this.isFlatRateSubItemDescVisibleToCust = appsettings.isFlatRateSubItemDescVisibleToCust;
      this.isFlatRateSubItemQtyVisibleToCust = appsettings.isFlatRateSubItemQtyVisibleToCust;
      this.displayExternalServiceNotes = appsettings.displayExternalServiceNotes;
      this.isFloridaStateComplianceUpdates = appsettings.isFloridaStateComplianceUpdates;
      this.isDisplayAuthorizationLogs = appsettings.displayAuthorizationDetails;
      this.isCAStateComplianceEnabled = appsettings.isCAStateComplianceEnabled;
      this.isTaxDetailsBreakDown = appsettings.isTaxDetailsBreakDown;
      this.isPassThroughTaxEnable = appsettings.isPassThroughTaxEnable;
      this.serviceItemsBreakdown = appsettings.serviceItemsBreakdown;
      this.isShowPaymentInPdf = appsettings.isShowPaymentInPdf;
      this.isTrackMileageInAndOut = appsettings.isTrackMileageInAndOut && appsettings.isMileageMandatory && appsettings.isMileageInAndOutEnabled;
      this.isEnhancedTSEnabled = appsettings.isEnhancedTSEnabled && appsettings.isTireStorageEnabled;
      this.isTreadDepthVisibleOnInvoice = appsettings.isTreadDepthVisibleOnInvoice;
      this.defaultMileageUnit = appsettings.mileageMeasuringUnit;
      this.isCustomerConcernEnabled = appsettings.isCustomerConcernEnabled;
      this.isWarrantyNumberAddonEnabled = appsettings.isWarrantyNumberAddonEnabled;
      this.isPartWarrantiesEnabled = appsettings.isPartWarrantiesEnabled;
      this.isTireWarrantyPolicyEnabled = appsettings.isTireWarrantyPolicyEnabled;
      this.isDvi2Enabled = appsettings.isDvi2Enabled;
      this.isTireStorage2Enabled = appsettings.isTireStorage2Enabled;
    }

    if (appsettings.isMultiLocationEnabled) {
      this.isTreadDepthVisibleOnInvoice = this.shopAppSettings.isTreadDepthVisibleOnInvoice;
      this.isTrackMileageInAndOut = this.shopAppSettings.isTrackMileageInAndOut && this.shopAppSettings.isMileageMandatory && this.shopAppSettings.isMileageInAndOutEnabled;
      this.isTaxDetailsBreakDown = this.shopAppSettings.isTaxDetailsBreakDown;
    }

    this.order = res.estimate;

    console.log('this.order', this.order);
    this.customer = res.estimate.customer;
    this.disclaimer = res.disclaimer || '';
    this.invDisclaimer = res.invDisclaimer || '';
    this.warrantyDisclaimer = res?.warrantyDisclaimer?.contents?.trim() || '';
    this.tireWarrantyPolicy = res?.tireWarrantyPolicy?.contents || '';
    this.vehicle = res.estimate?.vehicle?.vehicleId || {}; // (res.estimate.vehicle && res.estimate.vehicle.vehicleId) || {};
    this.pdfAuthHistory = res.estimate.estimateAuthHistory;

    this.warrantiedTires = res?.warrantiedTires?.map((tire) => {
      const sizeObj = this.helperService.tireSizeParser(tire.size);
      if (sizeObj.tireSize && sizeObj.tireWidth && sizeObj.tireProfile) {
        tire.size = `${sizeObj.tireWidth} ${sizeObj.tireProfile} R${sizeObj.tireSize}`;
      }
      return tire;
    }) || [];

    let serviceConcerns = [];
    if (this.isCustomerConcernEnabled) {
      this.order.services.forEach((res) => {
        if (res?.inspection?.inspectionId?.category) {
          this.orderInspectionItems = res?.inspection?.inspectionId?.category?.reduce((acc, curr) => {
            // Map each item to include the inspectionId
            const itemsWithId = curr.inspectionItems.map((item) => ({
              ...item,
              estimateInspectionId: res?.inspection?.inspectionId?._id,
            }));

            // Concatenate the modified items
            return acc.concat(itemsWithId);
          }, []);
        }
      });

      this.concerns = res?.concern || [];
      this.concerns.forEach((element, index) => {
        // Loop to handle services and push data into serviceConcerns
        if (element.services && element.services.length) {
          element.services.forEach((service) => {
            const data = {
              serviceId: service.serviceId,
              concernNumber: index + 1,
              id: element._id,
            };
            serviceConcerns.push(data);
          });
        }
        let updateFindings = [];
        if (element?.findings?.length) {
          // only process has findings
          // Loop to handle findings and conditions to get cannedNotes and name
          if (element.findings && element?.findings?.length) {
            element.findings.forEach((finding) => {
              const filteredData = finding.conditions?.filter((item) => item.isSelected);
              const updatedFinding = this.setUpdateFinding(finding.inspectionItemId); 
              const _finding = {
                ...finding,
                iconClass: inspectionItemColorIndex[updatedFinding?.colorIndex],
                class: findingItemIcon[updatedFinding?.colorIndex],
                actionText: this.currentLang === 'fr' ? findingItemColorLabelFR[updatedFinding?.colorIndex] : findingItemColorLabel[updatedFinding?.colorIndex],
                conditions: filteredData,
                inspectionId: finding.inspectionId,
                inspectionItemId: finding.inspectionItemId,
                _id: finding._id,
                notes: updatedFinding?.notes,
                measurement:updatedFinding?.measurement
              };              

              // let cannedNotes: string = '';

              // cannedNotes = filteredData
              //   .flatMap((item) => item.cannedNotes) // Extract and flatten all cannedNotes
              //   .join(' ');

              // _finding.cannedNotes = cannedNotes;

              // finding = _finding;
              if (_finding?.attachments) {
                _finding.attachments.sort((a, b) => {
                  const order = ['image', 'video', 'voice']; // desired order
                  return order.indexOf(a.type) - order.indexOf(b.type);
                });
              }

              updateFindings.push(_finding);
            });

            element.findings = updateFindings;
          }
        }
      });

      const sortOrder = ['customerConcern', 'safetyIssue', 'monitorTimeMileage', 'whileHere', 'maintainanceItem', 'cosmeticItem'];

      // Sorting function
      this.concerns.sort((a, b) => {
        return sortOrder.indexOf(a.concernType) - sortOrder.indexOf(b.concernType);
      });

      this.setConcernTypesCount();
    }

    if (this.vehicle) {
      this.vehicle.name = this.helperService.trimString(this.vehicle.name);
      this.vehicle.vehicleName = this.helperService.trimString(this.vehicle.vehicleName);
    }

    if (this.order.total && this.order.total.preTaxFee && this.order.total.preTaxFee.length) {
      this.order.total.preTaxFee = this.order.total.preTaxFee.map((fee: any) => {
        fee.name = fee.name.replace(new RegExp(' ', 'g'), '&nbsp;');
        return fee;
      });
    }

    if (this.order.createdAt) {
      this.order.createdAt = this.dateService.getCurrentDateTimeTz(new Date(this.order.backdatedCreationDate || this.order.createdAt).getTime(), res.company.timezone);
    }

    if (this.order.invoiceDate) {
      this.order.invoiceDate = this.dateService.getCurrentDateTimeTz(new Date(this.order.invoiceDate).getTime(), res.company.timezone);
    }

    if (this.disclaimer) {
      this.disclaimer = this.disclaimer.replace(/\n/g, '<br>');
    }

    if (this.invDisclaimer) {
      this.invDisclaimer = this.invDisclaimer.replace(/\n/g, '<br>');
    }

    if (this.warrantyDisclaimer) {
      this.warrantyDisclaimer = this.warrantyDisclaimer.replace(/\n/g, '<br>');
    }

    if (this.tireWarrantyPolicy) {
      this.tireWarrantyPolicy = this.tireWarrantyPolicy.replace(/\n/g, '<br>');
    }

    if (this.order?.services?.length) {
      const services = [];
      this.deferredServices = [];
      let serviceLevelItems = [];
      let serviceToCall = '';
      let orderInspectionItems;
      if (this.token) {
        orderInspectionItems = await this.httpService.getOrderInspectionItemsForCustomer({ _id: this.estimateId, token: this.token });
      } else {
        orderInspectionItems = await this.httpService.getOrderInspectionItems({ _id: this.estimateId });
      }
      const itemMap = new Map(orderInspectionItems.map((item: any) => [item.itemId, item.titleFR]));

      this.concerns?.forEach((concernObj: any) => {
        concernObj.findings?.forEach((concern: any) => {
          const titleFR = itemMap.get(concern.inspectionItemId);
          if (titleFR) {
            concern.titleFR = titleFR;
          }
        });
      });
      this.order.services.forEach((service: any) => {
        service.items = service.items.filter(({ isFlatRateSubItem }) => !isFlatRateSubItem);
        /*
        Here we mapping customer approval service status on customer pdf preview
        */
        service = this.formatService.formatTechDetailsAndAuthorizationPrintPreview(service, res.company.timezone);
        service.items.forEach((item: any) => {
          if (item.description) {
            item.description = item.description.replace(/\n/g, '<br>');
          }
          if (item.type === 'discount') {
            if (service.includeInInvoice) {
              this.serviceLevelDiscount.push(item);
            }
          } else if (this.isEnhancedTSEnabled && this.isTreadDepthVisibleOnInvoice && item.type === 'tireStorage' && item.tiresInfo?.length) {
            let lowerTreadDepthThreshold = this.company?.appsettings?.lowerTreadDepthThreshold;

            if (this.company?.appsettings?.isMultiLocationEnabled && this.shopAppSettings?.lowerTreadDepthThreshold) {
              lowerTreadDepthThreshold = this.shopAppSettings?.lowerTreadDepthThreshold;
            }

            item.tiresData = [...item.tiresInfo]
            item = this.helperService.formatTireInfoForCustomerScreens(item, lowerTreadDepthThreshold);
            if(!item.tiresInfo?.length && this.estimateId){
              item.tiresInfo = [...item.tiresData]
              item.tiresInfo.forEach(tire => {
                const tireInspectionInfo = orderInspectionItems.find(element => element.tireId === tire._id)
                const tireCondition = tireInspectionInfo?.conditions?.find(element => element.isSelected && element.name.split('/').length >= 2 && element.name.split('/')[1].includes('32'))
                
                if(!tireCondition) return;

                tire.treadDepth = tireCondition.name.split('/')[0].trim();
                if(tire.tireLabel === "Spare 1") tire.tirePosition = "S1";
                else if(tire.tireLabel === "Spare 2") tire.tirePosition = "S2";
                else tire.tirePosition = tire.tireLabel.split('(')[1].split(')')[0]
              });
              item = this.helperService.formatTireInfoForCustomerScreens(item, lowerTreadDepthThreshold);
            }
          }
        });

        service.items.forEach((item: any) => {
          if (item.type === 'bundle' && item.subItems && Array.isArray(item.subItems) && item.subItems.length > 0) {
            item.subItems.forEach((subItem: any) => {
              if (subItem.type === 'hazmatFee') {
                const { title, subTotal, titleFR } = subItem;
                hazmatFeeItems.push({ title, subTotal, titleFR: titleFR || '' });
              }
            });
          }
        });

        if (this.isCustomerConcernEnabled) {
          serviceConcerns.forEach((concern) => {
            if (service._id === concern.serviceId) {
              service.concernNumber = concern.concernNumber;
              this.addedServicesWithConcerns.push(service._id);
            }
          });
        }
      });
      this.flatRateFee = hazmatFeeItems;
      for (let i = 0; i < this.order.services.length; i++) {
        const { serviceStatus } = this.order.services[i];

        if (![serviceAuthConsts.declined, serviceAuthConsts.archived].includes(serviceStatus)) {
          if (serviceStatus === serviceAuthConsts.deferred || serviceStatus === serviceAuthConsts.deferredLocked) {
            this.deferredServices.push(this.order.services[i]);
          } else {
            services.push(this.order.services[i]);
          }
        }
      }
      for (let i = 0; i < services.length; i++) {
        const items = services[i].items.filter(({ type }) => type === 'hazmatFee');
        for (let j = 0; j < items.length; j++) {
          if (!items[j].isPassThroughTax) {
            serviceLevelItems = serviceLevelItems.concat(items[j]);
          }
        }
      }
      this.order.total.serviceLevelFeeItems = this.makeGroupedFees(serviceLevelItems);
      this.order.services = services;
    }

    if (this.customer?.customerId?.address) {
      const { addLine1 = '', city = '', stateCode = '', zip = '', country = '' } = this.customer.customerId.address;
      const addressArr = [addLine1, city, stateCode];

      if (addLine1 || city || stateCode || zip) {
        addressArr.push(country || '');
      }

      addressArr.push(zip || '');

      this.customer.address = addressArr.filter((str) => !!str).join(', ');
    }
    
    if (this.vehicle?.driver?.address) {
      const { addLine1 = '', city = '', stateCode = '', zip = '', country = '' } = this.vehicle?.driver?.address;
      const addressArr = [addLine1, city, stateCode];

      if (addLine1 || city || stateCode || zip) {
        addressArr.push(country || '');
      }

      addressArr.push(zip || '');

      this.vehicle.driver.address = addressArr.filter((str) => !!str).join(', ');
    }

    if (this.company?.address) {
      const { addLine1 = '', city = '', stateCode = '', country = '', zip = '' } = this.company.address;
      const addressArr = [addLine1, city, stateCode, country, zip];
      this.company.formattedAdress = addressArr.filter((str) => !!str).join(', ');
    }

    if (this.order?.vehicle?.vehicleId) {
      if (this.order.vehicleMileage?.reading && (this.order.vehicleMileage?.mileageMeasuringUnit || this.defaultMileageUnit)) {
        this.milage = {
          reading: this.order.vehicleMileage.reading,
          mileageMeasuringUnit: this.order.vehicleMileage.mileageMeasuringUnit ? this.order.vehicleMileage.mileageMeasuringUnit : this.defaultMileageUnit,
        };
      }
      if (this.order.vehicleMileageOut?.reading && this.order.vehicleMileageOut?.mileageMeasuringUnit) {
        this.mileageOut = {
          reading: this.order.vehicleMileageOut.reading,
          mileageMeasuringUnit: this.order.vehicleMileageOut.mileageMeasuringUnit,
        };
      }
    }

    if (appsettings?.isMultiLocationEnabled && shop) {
      const shopDetailsKey = ['name', 'logo', 'email', 'phone'];

      shopDetailsKey.forEach((key: string) => {
        if (shop[key]) {
          this.company[key] = shop[key];
        }
      });

      if (shop.pdfLogo) {
        this.company.logo = shop.pdfLogo;
        this.company.pdfLogo = shop.pdfLogo;
        this.pdfLogoType = shop?.appsettings?.pdfLogoFormatType;
      } else {
        this.company.logo = shop.logo;
        this.company.pdfLogo = shop.pdfLogo;
      }

      if (shop.address?.addLine1) {
        const { addLine1 = '', city = '', stateCode = '', country = '', zip = '' } = shop.address;
        const addressArr = [addLine1, city, stateCode, country, zip];

        this.company.formattedAdress = addressArr.filter((str) => !!str).join(', ');
      }

      if (shop?.appsettings) {
        this.isShowPaymentInPdf = shop.appsettings.isShowPaymentInPdf;
      }
    }

    this.isPaymentSectionVisible = (this.isShowPaymentDetails || this.isShowPaymentInPdf) && this.paymentHistory.length;
    this.isLoading = false;
    setTimeout(() => {
      window.print();
    }, 1000);
  }

  isServiceAdded(serviceId: string) {
    return this.addedServicesWithConcerns.includes(serviceId);
  }

  isServiceLinked(concern, service) {
    // if (!concern.findings) return false;
    return findIndex(concern.services, { serviceId: service._id }) === -1 ? false : true;
  }

  renderTotalPLTO() {
    if (this.order && this.order.total) {
      const { total, hazmatFee } = this.order.total;

      return Number(total) - Number(hazmatFee);
    }

    return 0;
  }

  showRawTotal() {
    if (this.order && this.order.total) {
      const { total, hazmatFee } = this.order.total;

      return total - Number(hazmatFee);
    }
    return 0;
  }

  makeGroupedFees(hazmatFees) {
    const feesGroup = [];
    hazmatFees.forEach((item) => {
      if (!this[item.itemId]) {
        this[item.itemId] = { title: item.title, titleFR: item?.titleFR || '', subTotal: 0 };
        feesGroup.push(this[item.itemId]);
      }
      this[item.itemId].subTotal += item.subTotal;
    });
    return feesGroup;
  }

  getConcernType(event, concern) {
    if (event === 'icon') return this.concernTypes.find((element) => element.value === concern.concernType)?.icon || concernsTypeList[0].icon;
    return this.concernTypes.find((element) => element.value === concern.concernType)?.label || concernsTypeList[0].label;
  }

  setUpdateFinding(inspectionItemId): any {
    try {
      return this.orderInspectionItems.filter((element) => inspectionItemId === element.itemId)[0];
    } catch {
      return {};
    }
  }
}
